import expandMacros from "./macros";

let automationTaskQueue = [];
let automationTaskInterval;

/**
 * Iterate over the automatic tasks to run
 */
const iterateAutomationTasks = () => {
  clearInterval(automationTaskInterval);

  if (0 === automationTaskQueue.length) {
    return;
  }

  /* shift the next task off the queue */
  const task = automationTaskQueue.shift();

  /* things will happen fast if you don't define a delay */
  const delay = "undefined" !== typeof (task.delay) ? task.delay : 1; /* ms */
  automationTaskInterval = setInterval(() => {
    /* the first thing we do after a setInterval is... */
    clearInterval(automationTaskInterval);

    /* go bald if no params are supplied */
    const params = task.params ? task.params : [];

    /* invoke the task */
    task.function.apply(null, params.map(p => {
      if ("string" === typeof (p)) {
        return expandMacros(p);
      }

      return p;
    }));

    /* invoke the iterator */
    iterateAutomationTasks();
  }, delay);
};

/**
 * Run tasks automatically
 *
 * @param tasks {Object[]} Format {function, delay, params}
 */
const runWorkFlow = tasks => {
  clearInterval(automationTaskInterval);
  automationTaskQueue = tasks;
  iterateAutomationTasks();
};

export default runWorkFlow;
